import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const subscriptionsActiveWidget: DashboardWidgetConfiguration = {
  widgetId: "subscriptions.active",
  name: "Active subscriptions",
  description: "Active subscriptions for the selected dashboard period.",
  apps: [
    "subscriptions",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "subscriptions.records",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "record_id",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "status",
        operator: "eq",
        value: "active",
      },
    },
  },
  inputs: {
    label: "Active subscriptions",
    subtext: "in the last 30 days",
    icon: "briefcase",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 248,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
